import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './accommodation-type.reducer';

export const AccommodationTypeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const accommodationTypeEntity = useAppSelector(state => state.accommodationType.entity);
  const loading = useAppSelector(state => state.accommodationType.loading);
  const updating = useAppSelector(state => state.accommodationType.updating);
  const updateSuccess = useAppSelector(state => state.accommodationType.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/accommodation-type${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllHouseholds !== undefined && typeof values.totalAllHouseholds !== 'number') {
      values.totalAllHouseholds = Number(values.totalAllHouseholds);
    }
    if (values.detached !== undefined && typeof values.detached !== 'number') {
      values.detached = Number(values.detached);
    }
    if (values.semiDetached !== undefined && typeof values.semiDetached !== 'number') {
      values.semiDetached = Number(values.semiDetached);
    }
    if (values.terraced !== undefined && typeof values.terraced !== 'number') {
      values.terraced = Number(values.terraced);
    }
    if (values.purposeBuiltBlockFlats !== undefined && typeof values.purposeBuiltBlockFlats !== 'number') {
      values.purposeBuiltBlockFlats = Number(values.purposeBuiltBlockFlats);
    }
    if (values.convertedSharedHouse !== undefined && typeof values.convertedSharedHouse !== 'number') {
      values.convertedSharedHouse = Number(values.convertedSharedHouse);
    }
    if (values.convertedBuilding !== undefined && typeof values.convertedBuilding !== 'number') {
      values.convertedBuilding = Number(values.convertedBuilding);
    }
    if (values.commercialBuilding !== undefined && typeof values.commercialBuilding !== 'number') {
      values.commercialBuilding = Number(values.commercialBuilding);
    }
    if (values.caravanMobile !== undefined && typeof values.caravanMobile !== 'number') {
      values.caravanMobile = Number(values.caravanMobile);
    }

    const entity = {
      ...accommodationTypeEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...accommodationTypeEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.accommodationType.home.createOrEditLabel" data-cy="AccommodationTypeCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.accommodationType.home.createOrEditLabel">Create or edit a AccommodationType</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="accommodation-type-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.geographicLevel')}
                id="accommodation-type-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.date')}
                id="accommodation-type-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.geography')}
                id="accommodation-type-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.geographyCode')}
                id="accommodation-type-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.totalAllHouseholds')}
                id="accommodation-type-totalAllHouseholds"
                name="totalAllHouseholds"
                data-cy="totalAllHouseholds"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.detached')}
                id="accommodation-type-detached"
                name="detached"
                data-cy="detached"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.semiDetached')}
                id="accommodation-type-semiDetached"
                name="semiDetached"
                data-cy="semiDetached"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.terraced')}
                id="accommodation-type-terraced"
                name="terraced"
                data-cy="terraced"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.purposeBuiltBlockFlats')}
                id="accommodation-type-purposeBuiltBlockFlats"
                name="purposeBuiltBlockFlats"
                data-cy="purposeBuiltBlockFlats"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.convertedSharedHouse')}
                id="accommodation-type-convertedSharedHouse"
                name="convertedSharedHouse"
                data-cy="convertedSharedHouse"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.convertedBuilding')}
                id="accommodation-type-convertedBuilding"
                name="convertedBuilding"
                data-cy="convertedBuilding"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.commercialBuilding')}
                id="accommodation-type-commercialBuilding"
                name="commercialBuilding"
                data-cy="commercialBuilding"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.accommodationType.caravanMobile')}
                id="accommodation-type-caravanMobile"
                name="caravanMobile"
                data-cy="caravanMobile"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/accommodation-type" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AccommodationTypeUpdate;
